export class ReporteEstadoPorSiloUtils {
  static parseDataCombinada (dataPorSilo, totales) {
    const total = totales.filas[0]
    dataPorSilo.filas.push({
      silo: `TOTAL`,
      sector: total.sector,
      linea: '',
      cereal: '',
      cerealVariedad: '',
      metrosDeVacio: total.metrosDeVacioTotal,
      pesoNetoBaseVigente: total.pesoNetoBaseVigente, // Capacidad actual del silo
      pesoNetoTotalBaseTrigo: total.pesoNetoTotalBaseTrigo, // Capacidad del silo en base cereal trigo
      pesoNetoTotalBaseVigente: total.pesoNetoTotalBaseVigente, // Capacidad del silo en base cereal actual
      espacio: total.espacioNetoTotal,
      espacioCamiones: total.espacioTotalCamiones
    })
    return dataPorSilo.filas
  }
}
